import axios from "axios";
import QRCode from "qrcode";

export function set_session(key, value) {
  localStorage.removeItem(key); // Remove session
  const data = {
    value,
  };
  localStorage.setItem(key, JSON.stringify(data));
}

export function get_session(key) {
  const data = localStorage.getItem(key);
  if (!data) return null;

  const parsed_data = JSON.parse(data);
  const current_time = new Date().getTime();

  // Check if the session has expired
  if (current_time > parsed_data.expiration) {
    localStorage.removeItem(key); // Remove expired session
    return null;
  }

  return parsed_data.value; // Return the valid session value
}

export function remove_session(key) {
  localStorage.removeItem(key); // Remove session
}

export function calculate_won_to_sats(won, btc_price) {
  return Math.floor(won * (10 ** 8 / btc_price));
}

export async function get_btc_price() {
  try {
    const api = process.env.VUE_APP_API_URL + "/btcprice";
    const { data } = await axios.get(api);
    return data;
  } catch (error) {
    console.error("Failed to get btc price : ", error);
  }
}
export function convert_to_strfmt(val) {
  return Math.round(val).toLocaleString("en-US");
}

export function get_dialog_width(screen_width) {
  if (screen_width >= 1200) {
    return "60%";
  } else if (screen_width >= 700) {
    return "60%";
  } else {
    return "90%;";
  }
}
export function pop_noti(instance, type, message) {
  switch (type) {
    case "danger":
      instance.$message.error(message);
      break;
    case "success":
      instance.$message.success(message);
      break;
    case "warning":
      instance.$message.warning(message);
      break;
    default:
      instance.$message.info(message);
      break;
  }
}

export async function create_qrcode(msg) {
  try {
    const data_url = await QRCode.toDataURL(msg, {
      width: 200,
      margin: 2,
      color: { dark: "#000", light: "#FFF" },
    });
    return data_url; // Return the generated QR code data URL
  } catch (error) {
    console.error("Failed to generate QR code:", error);
    return null;
  }
}

export async function get_faq() {
  try {
    const api = process.env.VUE_APP_API_URL + "/faq";
    const { data } = await axios.get(api);
    return data;
  } catch (error) {
    console.error("Failed to get faq: ", error);
  }
}
